export const DELETE_EVENT_PROMPT = `
Date format: YYYY-MM-DDThh:mm:ss+00:00
Based on this event description: "{query}", output a JSON string of the
following parameters. Do not include any other text or comments: 
Today's datetime on UTC time {date}, it's {dayName} and timezone of the user {u_timezone},
take into account the timezone of the user and today's date.
1. event_id
2. event_summary
3. time_min
4. time_max
5. user_timezone
output:
`;
